<template>
  <div v-if="pickupPoints.length" class="pickup-points">
    <SfRadio
      v-for="point in pickupPoints"
      :key="point.Id"
      :label="point.Name"
      :details="getAddressText(point.Address)"
      :description="point.description"
      name="PickupPoints"
      :value="point.Address.Id"
      :required="true"
      v-model="address"
      @input="handleInputChange(point)"
    />
  </div>
</template>
<script>
import {
  SfRadio,
} from '@storefront-ui/vue';
import { config } from '@/modules/core';

export default {
  name: 'PickupPoints',
  mixins: [config],
  components: {
    SfRadio,
  },
  props: {
    pickupPoints: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      address: '',
    };
  },
  created() {
    this.pickupPoints.forEach((point) => {
      if (point.Default) {
        this.handleInputChange(point);
      }
    });
  },
  watch: {
    value: {
      handler() {
        this.address = this.value.address;
      },
      immediate: true,
    },
  },
  methods: {
    getAddressText(address) {
      return `${address.Address1 || ''} ${address.Address2 || ''} ${address.City || ''} ${this.getCountryAndStateToName('countries', address.CountryId) || ''}`;
    },
    handleInputChange(data) {
      this.$emit('input', {
        address: data.Address.Id,
        id: data.Id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.sf-button,
.sf-input,
.sf-checkbox {
  margin-bottom: var(--spacer-sm);
}

</style>
